import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function init() {
	if (window.matchMedia("(max-width: 768px)").matches) return;
	
	const items = document.querySelectorAll('.js-fixed-section');

	items.forEach(item => {
		if (item.offsetHeight <= (window.innerHeight + 120)) {
			item.classList.add('sticky');
		}
	});

	items.forEach(el => {
	    gsap.timeline({
	        scrollTrigger: {
	            trigger: el,
	            start: 'bottom bottom',
	            end: '+=100%',
	            scrub: true
	        }
	    })
	    .to(el, {
	        ease: 'none',
	        yPercent: -5,
	        alpha: 0,
	        scale: 0.75
	    }, 0)
	});
}